export const clientId = "smx-quality-agreement";
